import { createApp } from 'vue'
import RomaSayilari from './RomaSayilari.vue'
import './assets/global.css'

createApp(RomaSayilari).mount('#roma-sayilari')
